module.exports = {
      id: "media-placeholder-usage",
      viewBox: "0 0 632 421",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#media-placeholder",
      toString: function () {
        return this.url;
      }
    }